import { motion } from "framer-motion";
import { TrendingUp, TrendingDown, Sparkles } from "lucide-react";

export const HighlightCard = ({ 
  title, 
  description, 
  metric, 
  isPositive,
  delay = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -16 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4, delay }}
      className={`highlight-card p-5 ${isPositive ? 'positive' : 'negative'}`}
      data-testid={`highlight-card-${title.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 space-y-2">
          <div className="flex items-center gap-2">
            <Sparkles className={`w-4 h-4 ${isPositive ? 'text-emerald-600' : 'text-red-600'}`} />
            <h4 className="font-heading font-semibold text-slate-800 text-sm md:text-base">
              {title}
            </h4>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed">
            {description}
          </p>
        </div>
        <div className={`flex items-center gap-1 px-3 py-2 rounded-lg ${
          isPositive 
            ? 'bg-emerald-100 text-emerald-700' 
            : 'bg-red-100 text-red-700'
        }`}>
          {isPositive ? (
            <TrendingUp className="w-4 h-4" />
          ) : (
            <TrendingDown className="w-4 h-4" />
          )}
          <span className="font-heading font-bold text-lg">
            {metric}
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default HighlightCard;
